export type CodeTheme = 'clean' | 'midnight' | 'sunset' | 'forest'
export type QrFrame = 'none' | 'rounded' | 'label'

export interface CodeAppearance {
  theme: CodeTheme
  accentColor: string
  qrDarkColor: string
  qrLightColor: string
  qrFrame: QrFrame
}

export const defaultAppearance: CodeAppearance = {
  theme: 'clean',
  accentColor: '#2563eb',
  qrDarkColor: '#0f172a',
  qrLightColor: '#ffffff',
  qrFrame: 'rounded',
}

export const themeStyles: Record<CodeTheme, { background: string; foreground: string }> = {
  clean: { background: 'linear-gradient(160deg,#eff6ff,#ffffff)', foreground: '#0f172a' },
  midnight: { background: 'linear-gradient(160deg,#020617,#172554)', foreground: '#f8fafc' },
  sunset: { background: 'linear-gradient(160deg,#fff7ed,#fce7f3)', foreground: '#4c0519' },
  forest: { background: 'linear-gradient(160deg,#ecfdf5,#d1fae5)', foreground: '#052e16' },
}

export const messageTemplates = [
  { name: 'Event', message: 'You found the secret event page 🎉\nDetails coming soon.' },
  { name: 'Lost item', message: 'Found this? Thank you! Please contact me so I can get it back.' },
  { name: 'Profile', message: 'Hey, I’m [your name]. Tap the links below to learn more.' },
  { name: 'Promotion', message: 'You scanned it—here’s your exclusive offer.' },
]
